import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ClubPlansListApi = (data) => API.get(`${URL.CLUB_PLANS_LIST}`, data)
